import { Field } from "@base-ui/react/field";
import { Controller, useFormContext } from "react-hook-form";
import type { FormField } from "@/types/academy";

const FormInput = ({ block }: { block: FormField }) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      defaultValue={block.prefillValue || ""}
      name={block.id}
      render={({ field, fieldState }) => {
        return (
          <Field.Root
            className="flex w-2/3 flex-col items-start gap-1"
            dirty={fieldState.isDirty}
            invalid={fieldState.invalid}
            name={block.id}
            touched={fieldState.isTouched}
          >
            <Field.Label className="text-sm font-bold text-gray-900">
              {block.label}
            </Field.Label>
            <Field.Control
              className="h-10 w-full rounded-md border border-gray-200 pl-3.5 text-base text-gray-900 focus:outline-2 focus:-outline-offset-1 focus:outline-blue-800 font-normal"
              onBlur={field.onBlur}
              onValueChange={field.onChange}
              placeholder={block.placeholder}
              ref={field.ref}
              type="text"
              value={field.value}
            />
            <Field.Error
              className="text-sm text-red-600 font-medium"
              match={!!fieldState.error}
            >
              {block.helperText || "Bu alan zorunludur"}
            </Field.Error>

            <Field.Description className="text-sm text-gray-600" />
          </Field.Root>
        );
      }}
      rules={{
        required: block.isRequired,
      }}
    />
  );
};

export default FormInput;
